import { deepEqual } from '@empathybroker/deep-equal';

import { ActionContext } from 'vuex';

import { ActionClass, ContextState } from '../../../models';

import { CONTEXT_CONSTS } from '../../../store/context/context.consts';

export class SetContextAction implements ActionClass {

  public static execute({ state, commit }: ActionContext<ContextState, any>, context: ContextState): Promise<boolean> {
    const contextHasChanged = !deepEqual(context, state);
    if (contextHasChanged) {
      commit(CONTEXT_CONSTS.mutations.setContext, context);
    }
    return Promise.resolve(contextHasChanged);
  }

}
